module.exports = "<p class=\"version-p\">\n  Quelix Admin rel.  <strong>{{version}}</strong>\n</p>\n"